import React, { Component } from 'react';
import qs from 'qs';
import {
  create as createAnnouncement,
  load as loadAnnouncement,
  edit as editAnnouncement,
  generate as generateDrafts
} from '../services/announcementService';
import { uploadImage as uploadNewsImage, getImageUrl } from '../services/newsService';
import ImageUploader from 'react-images-upload';
import {
  Box,
  Paper,
  Stack,
  Typography,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  Snackbar,
  Alert,
  CircularProgress,
  IconButton
} from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

class FormAnnouncement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: '',
      description: '',
      audience: 'all',
      links: [],
      image: undefined,
      status: 'draft',
      pictures: [],
      submitting: false,
      generating: false,
      snackbar: { open: false, severity: 'success', message: '' }
    };

    this._isMounted = false;
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleGenerate = this.handleGenerate.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.closeSnackbar = this.closeSnackbar.bind(this);
    this.addLink = this.addLink.bind(this);
    this.removeLink = this.removeLink.bind(this);
    this.handleLinkChange = this.handleLinkChange.bind(this);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  async componentDidMount() {
    this._isMounted = true;
    const parsed = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
    if (parsed.announcement_id && parsed.announcement_id.length > 0) {
      try {
        const announcement = await loadAnnouncement(parsed.announcement_id);
        if (!this._isMounted) return;
        this.setState({
          title: announcement.title || '',
          description: announcement.description || '',
          audience: announcement.audience || 'all',
          links: announcement.links || [],
          image: announcement.image || undefined,
          status: announcement.status || 'draft'
        });
      } catch (e) {
        if (!this._isMounted) return;
        this.setState({ snackbar: { open: true, severity: 'error', message: 'Erreur lors du chargement.' } });
      }
    }
  }

  closeSnackbar() {
    this.setState({ snackbar: { ...this.state.snackbar, open: false } });
  }

  handleInputChange(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }

  addLink() {
    this.setState({ links: [...this.state.links, { label: '', url: '' }] });
  }

  removeLink(index) {
    const links = [...this.state.links];
    links.splice(index, 1);
    this.setState({ links });
  }

  handleLinkChange(index, field, value) {
    const links = [...this.state.links];
    links[index] = { ...links[index], [field]: value };
    this.setState({ links });
  }

  onDrop(pictureFiles) {
    if (!pictureFiles || pictureFiles.length === 0) return;
    this.setState({ pictures: this.state.pictures.concat(pictureFiles) });
    uploadNewsImage(pictureFiles[0])
      .then((res) => {
        if (!this._isMounted) return;
        this.setState({ image: res._id, snackbar: { open: true, severity: 'success', message: 'Image upload\u00e9e.' } });
      })
      .catch(() => {
        if (!this._isMounted) return;
        this.setState({ snackbar: { open: true, severity: 'error', message: 'Erreur upload image.' } });
      });
  }

  async handleSubmit(event) {
    event.preventDefault();

    const { title, description, audience, links, image } = this.state;

    if (!title || !description) {
      this.setState({ snackbar: { open: true, severity: 'warning', message: 'Titre et description sont requis.' } });
      return;
    }

    const payload = { title, description, audience, links };
    if (image) payload.image = image;

    const parsed = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
    const isEdit = parsed.announcement_id && parsed.announcement_id.length > 0;

    this.setState({ submitting: true });
    try {
      if (isEdit) {
        await editAnnouncement(parsed.announcement_id, payload);
        if (!this._isMounted) return;
        this.setState({ snackbar: { open: true, severity: 'success', message: 'Annonce sauvegard\u00e9e.' } });
      } else {
        const created = await createAnnouncement(payload);
        if (!this._isMounted) return;
        this.setState({ snackbar: { open: true, severity: 'success', message: 'Annonce cr\u00e9\u00e9e.' } });
        // Redirect to edit mode so the user can generate drafts
        if (created && created._id) {
          setTimeout(() => { if (this._isMounted) this.props.history.push(`/super-admin/FormAnnouncement?announcement_id=${created._id}`); }, 600);
        } else {
          setTimeout(() => { if (this._isMounted) this.props.history.push('/super-admin/ListAnnouncements'); }, 600);
        }
      }
    } catch (e) {
      if (!this._isMounted) return;
      this.setState({ snackbar: { open: true, severity: 'error', message: "Erreur lors de l'enregistrement." } });
    } finally {
      if (this._isMounted) this.setState({ submitting: false });
    }
  }

  async handleGenerate() {
    const parsed = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
    if (!parsed.announcement_id) return;

    this.setState({ generating: true });
    try {
      await generateDrafts(parsed.announcement_id);
      if (!this._isMounted) return;
      this.setState({ snackbar: { open: true, severity: 'success', message: 'Brouillons g\u00e9n\u00e9r\u00e9s !' } });
      setTimeout(() => { if (this._isMounted) this.props.history.push(`/super-admin/ReviewAnnouncement?announcement_id=${parsed.announcement_id}`); }, 600);
    } catch (e) {
      if (!this._isMounted) return;
      this.setState({ snackbar: { open: true, severity: 'error', message: 'Erreur lors de la g\u00e9n\u00e9ration.' } });
    } finally {
      if (this._isMounted) this.setState({ generating: false });
    }
  }

  render() {
    const { title, description, audience, links, image, submitting, generating, snackbar } = this.state;
    const parsed = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
    const isEdit = parsed.announcement_id && parsed.announcement_id.length > 0;

    return (
      <Box sx={{ p: 2 }}>
        <Paper variant="outlined" sx={{ p: 3, maxWidth: 900, mx: 'auto' }}>
          <Stack spacing={3}>
            <Typography variant="h6">{isEdit ? 'Modifier une annonce' : 'Nouvelle annonce'}</Typography>

            {image && (
              <Box sx={{ minWidth: 200 }}>
                <img src={getImageUrl(image)} alt="announcement" style={{ maxWidth: '100%', maxHeight: 150, borderRadius: 4 }} />
              </Box>
            )}
            <ImageUploader
              withIcon={true}
              withPreview={true}
              maxFileSize={2097152}
              label="Max: 2mb, formats: jpg / png / gif"
              buttonText="Choisir une image"
              onChange={this.onDrop}
              imgExtension={['.jpg', '.gif', '.png']}
            />

            <Box component="form" onSubmit={this.handleSubmit}>
              <Stack spacing={2}>
                <TextField
                  label="Titre de la feature"
                  name="title"
                  value={title}
                  onChange={this.handleInputChange}
                  fullWidth
                  required
                />

                <TextField
                  label="Description"
                  name="description"
                  value={description}
                  onChange={this.handleInputChange}
                  fullWidth
                  required
                  multiline
                  rows={6}
                />

                <FormControl fullWidth>
                  <InputLabel id="audience-label">Audience cible</InputLabel>
                  <Select
                    labelId="audience-label"
                    name="audience"
                    label="Audience cible"
                    value={audience}
                    onChange={this.handleInputChange}
                  >
                    <MenuItem value="all">Tous</MenuItem>
                    <MenuItem value="free">Free</MenuItem>
                    <MenuItem value="expert">Expert</MenuItem>
                    <MenuItem value="custom">Custom</MenuItem>
                  </Select>
                </FormControl>

                {/* Liens dynamiques */}
                <Box>
                  <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                    <Typography variant="subtitle2">Liens</Typography>
                    <IconButton size="small" onClick={this.addLink} color="primary">
                      <AddCircleOutlineIcon fontSize="small" />
                    </IconButton>
                  </Stack>
                  {links.map((link, index) => (
                    <Stack key={index} direction="row" spacing={1} sx={{ mb: 1 }} alignItems="center">
                      <TextField
                        label="Label"
                        size="small"
                        value={link.label || ''}
                        onChange={(e) => this.handleLinkChange(index, 'label', e.target.value)}
                        sx={{ flex: 1 }}
                      />
                      <TextField
                        label="URL"
                        size="small"
                        value={link.url || ''}
                        onChange={(e) => this.handleLinkChange(index, 'url', e.target.value)}
                        sx={{ flex: 2 }}
                      />
                      <IconButton size="small" onClick={() => this.removeLink(index)} color="error">
                        <DeleteOutlineIcon fontSize="small" />
                      </IconButton>
                    </Stack>
                  ))}
                </Box>

                <Stack direction="row" spacing={2} justifyContent="flex-end">
                  {isEdit && (
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={this.handleGenerate}
                      disabled={generating}
                      startIcon={generating ? <CircularProgress size={18} /> : null}
                    >
                      {generating ? 'G\u00e9n\u00e9ration en cours...' : 'G\u00e9n\u00e9rer les brouillons'}
                    </Button>
                  )}
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={submitting}
                    startIcon={submitting ? <CircularProgress size={18} /> : null}
                  >
                    {submitting ? 'Sauvegarde...' : 'Sauvegarder'}
                  </Button>
                </Stack>
              </Stack>
            </Box>
          </Stack>
        </Paper>

        <Snackbar
          open={snackbar.open}
          autoHideDuration={3000}
          onClose={this.closeSnackbar}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
          <Alert onClose={this.closeSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Box>
    );
  }
}

export default FormAnnouncement;
